// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0b8306fe","977":"a558e981"}[chunkId] + ".chunk.js";
};